import { SecuredLayout } from '../Layout/SecuredLayout';
import { useEffect, useState } from 'react';
import { usePreconfiguredFetch } from '../../hooks/useProvidePreconfiguredFetch';

export default function HealthIndex() {
    const { fetchResource } = usePreconfiguredFetch()
    const [status, setStatus] = useState('');

    const fetchHealth = async () => {
        const resp = await fetchResource('/api/health');
        const body = await resp.text();
        setStatus(`${resp.status} | ${body}`);
    };

    useEffect(() => {
        fetchHealth();
    }, []);

    return (
        <SecuredLayout>
            <div>{status}</div>
        </SecuredLayout>
    );
}
